import React, { useState, useEffect, useContext, useRef } from "react";
import ScrollToTop from "react-scroll-to-top";
import styled, { ThemeProvider } from "styled-components";
//import Head from "next/head";
import AOS from "aos";
import { Helmet } from "react-helmet";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
 
 
import SidebarDashboard from "./SidebarDashboard/SidebarDashboard";
import ModalVideo from "./ModalVideo/ModalVideo";
import ModalApplication from "./ModalApplication/ModalApplication";
import ModalSignIn from "./ModalSignIn/ModalSignIn";
import ModalSignUp from "./ModalSignUp/ModalSignUp";
import ModalGeneral from "./ModalGeneral/ModalGeneral";

import ModalError from "./ModalError/ModalError";
import ModalSuccess from "./ModalSuccess/ModalSuccess";
import ModalConfirm from "./ModalConfirm/ModalConfirm";
import ModalLoader from "./ModalConfirm/ModalLoad";
import ModalPassword from "./ModalPassword/ModalPassword";
import ModalForgotPassword from "./ModalForgotPassword/ModalForgotPassword";
import Cookies from "./Cookies/Cookies";
import GlobalContext from "../context/GlobalContext";

import GlobalStyle from "../utils/globalStyle"; 
import { get, merge } from "lodash";
import { useLocation } from 'react-router-dom';
// the full theme object
import { theme as baseTheme } from "../utils";
import Chatbot from 'react-chatbot-kit'
import 'react-chatbot-kit/build/main.css'
import config from "../chatbot/config"
import MessageParser from '../chatbot/MessageParser.js';
import ActionProvider from '../chatbot/ActionProvider.js';
import Zendesk, { ZendeskAPI, ZendeskEndChat } from "../ZendeskConfig";

// options for different color modes
const modes = { light: "light", dark: "dark" };

// merge the color mode with the base theme
// to create a new theme object
const getTheme = (mode) =>
  merge({}, baseTheme, {
    colors: get(baseTheme.colors.modes, mode, baseTheme.colors),
  });

  
 

const Layout = ({ children, pageContext }) => {
    const gContext = useContext(GlobalContext);
   
    const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY;
    const [errorMessage, setErrorMessage] = React.useState('');
    const [visibleLoader, setVisibleLoader] = useState(true);
    const [showCookies, setShowCookies] = useState(false);
    const [showScrollup, setShowScrollup] = useState(false);
    const [chatbotReady, setChatbotReady] = useState(false);
    
    const pathName = useLocation().pathname.toLowerCase();
    function changeStatus() {
        // setStatus(navigator.onLine);
        // setErrorMessage(navigator.onLine ? "" : "No internet");
        if (!navigator.onLine && pathName.trim().toLowerCase() != "/servererror")
            window.location.href = "/servererror";
    }
    useEffect(() => {
         
        //changeStatus();
        //window.addEventListener("online", changeStatus);
        //window.addEventListener("offline", changeStatus);
        //return () => {
        //    window.removeEventListener("online", changeStatus);
        //    window.removeEventListener("offline", changeStatus);
        //};
        window.sessionStorage.clear();
        AOS.init({ once: true });
        setVisibleLoader(false);
        setShowCookies(document.cookie.indexOf("accepted_cookies=") < 0); 
        const customizeZendeskChat = () => {         

            for (var i = 0; i < document.getElementsByTagName("iframe").length; i++) {
                if (document.getElementsByTagName("iframe")[i].name == "Messaging window") {

                    document.getElementsByTagName("iframe")[i].className = "zenChat";
                }
            }
        }
        const openZendeskChat = () => {         

            if (window.zE) {
                if (pathName == "/") {
                    window.zE('messenger', 'open');
                    setTimeout(customizeZendeskChat, 300);
                }
                else {
                    window.zE('messenger', 'open');
                    window.zE('messenger', 'close');
                }

            } else {
                setTimeout(customizeZendeskChat, 800);
                setTimeout(openZendeskChat, 100); // Retry after 100ms if zE is not available
            }
        }

        // Do not auto-open Zendesk on initial load — we'll open it after the chatbot delay
        customizeZendeskChat();

        // Delay readiness and auto-opening the chatbot by 60 seconds after page load
        console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Initial state - chatbotReady:", chatbotReady, ", gContext.showBot:", gContext.showBot);
        console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Checking for chatbot-overlay div on initial load:", document.querySelector('.chatbot-overlay'));
        
        const chatbotAutoOpenTimer = setTimeout(() => {
          console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- 60s timer fired!");
          console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- DOM check - chatbot-overlay exists?:", !!document.querySelector('.chatbot-overlay'));
          try {
            setChatbotReady(true);
            if (!gContext.showBot) {
              console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Setting showBot to true");
              gContext.toggleBot(true);
            }
            // After chatbot readiness, open Zendesk messenger (if available)
            try {
              console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Opening Zendesk messenger after delay (if available)");
              openZendeskChat();
            } catch (ze) {
              console.warn("[CHATBOT DEBUG]", new Date().toISOString(), "- openZendeskChat failed:", ze);
            }
          } catch (e) {
            console.error("[CHATBOT DEBUG]", new Date().toISOString(), "- Error:", e);
          }
        }, 60000);

        return () => {
          clearTimeout(chatbotAutoOpenTimer);
        };

      }, []);

    useEffect(() => {
        if (errorMessage != "") {
            gContext.setErrorModal(errorMessage);
            gContext.toggleErrorModal();
        }
    }, [errorMessage]);

    useEffect(() => {
      console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- State changed - chatbotReady:", chatbotReady, ", gContext.showBot:", gContext.showBot);
      console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- DOM check after state change - chatbot-overlay exists?:", !!document.querySelector('.chatbot-overlay'));
    }, [chatbotReady, gContext.showBot]);

  // Navbar style based on scroll
  const eleRef = useRef();

  
  useEffect(() => {
    window.addEventListener(
      "popstate",
      function (event) {
        // The popstate event is fired each time when the current history entry changes.
        gContext.closeOffCanvas();
      },
      false
    );
    window.addEventListener(
      "pushState",
      function (event) {
        // The pushstate event is fired each time when the current history entry changes.
        gContext.closeOffCanvas();
      },
      false
    );
  }, [gContext]);
 
    const handleScrollupButton =()=> {

        
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 0) {
            setShowScrollup(true)
        }
        else  {
            setShowScrollup(false)
        }
    }
    const scrollToTop=()=> {

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
           
        });
    }


  if (pageContext.layout === "bare") {
    return (
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
        >
            {(pathName.trim().toLowerCase() != "/" && pathName.trim().toLowerCase() != "/searchexpert" && pathName.trim().toLowerCase() != "/searchjob") && <Helmet>
                 
                <meta name="description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
                <meta name="og:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
                <meta name="twitter:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
            </Helmet>}
        <div data-theme-mode-panel-active data-theme="light">
          <GlobalStyle /> 
          
                
                <div className="site-wrapper overflow-hidden ShowScrollup" ref={eleRef}>
                    {children}
                    <Cookies/>
          </div>
                <ModalGeneral />
          <ModalVideo />
          <ModalApplication />
                {gContext.signInModalVisible && <ModalSignIn />}
                {gContext.signUpModalVisible && <ModalSignUp />}
                <ModalLoader />
                <ModalError />
                <ModalSuccess />
                <ModalPassword />
                {chatbotReady && gContext.showBot && (
                  <>
                    {console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Rendering Chatbot overlay (bare) - chatbotReady:", chatbotReady, ", showBot:", gContext.showBot)}
                    <div className="chatbot-overlay" style={{ height: '60vh', maxHeight: '60vh', overflow: 'hidden', position: 'fixed', right: '0px', bottom: '0px', top: 'auto', left: 'auto', zIndex: 999999999, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>  
                      <Chatbot
                        config={config}
                        messageParser={MessageParser}
                        actionProvider={ActionProvider}
                        headerText={<> <text style={{ width: "340px" }}>Chat with Syncuppro &nbsp;</text> <a style={{ color: "#585858", fontWeight: "bold", borderRadius: "0px", width: "250", alignContent: "end", marginRight: "0" }} className="align-right" href="#" onClick={() => gContext.toggleBot((prev) => !prev)}><i className="fas fa-times"></i></a></>}
                        close="true"
                      />
                    </div>
                  </>
                )}
                {(gContext.showBotBubble && !gContext.showBot) && <div className="chatbot-bubble text-center align-center pointer" onClick={() => gContext.toggleBot(true)}>  <span className="f-24  text-white m-icon material-icons align-middle m-t-20">chat</span>
                </div>}
                <Zendesk defer zendeskKey={ZENDESK_KEY} />
        </div>
      </ThemeProvider>
    );
  }

  if (pageContext.layout === "dashboard") {
    return (
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
        > {(pathName.trim().toLowerCase() != "/" && pathName.trim().toLowerCase() != "/searchexpert" && pathName.trim().toLowerCase() != "/searchjob") && <Helmet>

            <meta name="description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
            <meta name="og:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
            <meta name="twitter:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
        </Helmet>}
        <div data-theme-mode-panel-active data-theme="light" >
          <GlobalStyle />
        
                    <Header ref={eleRef} isDark={gContext.headerDark} />
                
                        {children}


                    <Cookies />

                <ScrollToTop smooth="true" component={< i className="fa fa-arrow-up text-white  font-size-7"></i>} className="btn-circle  scroll-up media-icon     bg-green rounded-5  text-white  font-size-7  " />
                    <div  className="d-none smin-h-100vh w-100"></div>
                    <Footer isDark={gContext.footerDark} />
                        
           
         
                <ModalGeneral />
                <ModalVideo />
                <ModalConfirm />
          <ModalApplication />
               
                <ModalError />
                <ModalSuccess />
                {gContext.signInModalVisible && <ModalSignIn />}
                {gContext.signUpModalVisible && <ModalSignUp />}
                <ModalLoader />
                <ModalPassword />
                {chatbotReady && gContext.showBot && (
                  <>
                    {console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Rendering Chatbot overlay (dashboard) - chatbotReady:", chatbotReady, ", showBot:", gContext.showBot)}
                    <div className="chatbot-overlay" style={{ height: '60vh', maxHeight: '60vh', overflow: 'hidden', position: 'fixed', right: '0px', bottom: '0px', top: 'auto', left: 'auto', zIndex: 999999999, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>  
                      <Chatbot
                        config={config}
                        messageParser={MessageParser}
                        actionProvider={ActionProvider}
                        headerText={<> <text style={{ width: "340px" }}>Chat with Syncuppro &nbsp;</text> <a style={{ color: "#585858", fontWeight: "bold", borderRadius: "0px", width: "250", alignContent: "end", marginRight: "0" }} className="align-right" href="#" onClick={() => gContext.toggleBot((prev) => !prev)}><i className="fas fa-times"></i></a></>}
                        close="true"
                      />
                    </div>
                  </>
                )}
                {(gContext.showBotBubble && !gContext.showBot) && <div className="chatbot-bubble text-center align-center pointer" onClick={() => gContext.toggleBot(true)}>  <span className="f-24  text-white m-icon material-icons align-middle m-t-20">chat</span>
                </div>}
                <Zendesk defer zendeskKey={ZENDESK_KEY} />
        </div>
      </ThemeProvider>
    );
  }
   
  return (
    <>
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
          >
              {(pathName.trim().toLowerCase() != "/" && pathName.trim().toLowerCase() != "/searchexpert" && pathName.trim().toLowerCase() != "/searchjob") && <Helmet>

                  <meta name="description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
                  <meta name="og:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
                  <meta name="twitter:description" content="Hire the Best Compliance Expert for your needs.Ensure compliance success with the industry's top expert by your side." />
              </Helmet>}
        <div data-theme-mode-panel-active data-theme="light">
          <GlobalStyle />  
          <div className="site-wrapper overflow-hidden" ref={eleRef}>
            <Header isDark={gContext.headerDark} />
            {children}
                      <Cookies />
                    
                      <div style={{ display: showScrollup ? 'inline' : 'none' }} className="btn-circle   scroll-up media-icon px-5 py-5 bg-green rounded-5" onClick={scrollToTop}>
                          
                      </div>
                      <ScrollToTop smooth="true" component={< i className="fa fa-arrow-up text-white  font-size-7"></i>} className="btn-cirlce  scroll-up media-icon     bg-green rounded-5  text-white  font-size-7 "/>
                      
                      <Footer isDark={gContext.footerDark} />
                      <ModalGeneral />
                      <ModalVideo />
                      <ModalApplication />
                      {gContext.signInModalVisible && <ModalSignIn />}
                      {gContext.signUpModalVisible && <ModalSignUp />}
                      <ModalError />
                      <ModalSuccess/>
                      <ModalConfirm/>
                      {gContext.forgotPasswordModalVisible && <ModalForgotPassword />}
                      <ModalLoader />
                      <ModalPassword />
                      {chatbotReady && gContext.showBot && (
                        <>
                          {console.log("[CHATBOT DEBUG]", new Date().toISOString(), "- Rendering Chatbot overlay (default) - chatbotReady:", chatbotReady, ", showBot:", gContext.showBot)}
                          <div className="chatbot-overlay" style={{ height: '60vh', maxHeight: '60vh', overflow: 'hidden', display:'none', position: 'fixed', right: '0px', bottom: '0px', top: 'auto', left: 'auto', zIndex: 999999999, alignItems: 'flex-end', justifyContent: 'flex-end' }}>  
                            <Chatbot
                              config={config}
                              messageParser={MessageParser}
                              actionProvider={ActionProvider}
                              headerText={<> <text style={{ width: "340px" }}>Syncuppro ChatBot</text> <a style={{ color: "#585858", fontWeight: "bold", borderRadius: "0px", width: "250", alignContent: "end", marginRight: "0" }} className="align-right" href="#" onClick={() => gContext.toggleBot((prev) => !prev)}><i className="fas fa-times"></i></a></>}
                              close="true"
                            />
                          </div>
                        </>
                      )}
                      {(gContext.showBotBubble && !gContext.showBot)  && <div className="chatbot-bubble text-center align-center pointer" onClick={() => gContext.toggleBot(true)}>  <span className="f-24  text-white m-icon material-icons align-middle m-t-20">chat</span>
                      </div>}
                      <Zendesk defer zendeskKey={ZENDESK_KEY} />
          </div>

        </div>
          </ThemeProvider>
          <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=d3b68e27-c13e-4e15-a11b-b9ea01b0aec4"></script>
    </>
  );
};

export default Layout;
